"use client";

import { faSquare, faSquareCheck } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import camelCaseToKebab from "@shared/functions/camelCaseToKebab";
import type { FieldInputProps } from "formik";
import type { DetailedHTMLProps, InputHTMLAttributes } from "react";
import { useEffect, useState } from "react";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "name"> & {
	field?: FieldInputProps<
		DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>
	>;
	label: string;
	name: string;
};

export default function Checkbox({
	checked,
	hidden,
	label,
	onChange,
	...props
}: Props) {
	const isControlled = checked !== undefined;
	const [isChecked, setIsChecked] = useState(checked ?? false);

	useEffect(() => {
		if (isControlled) {
			setIsChecked(checked);
		}
	}, [checked, isControlled]);

	if (!props.id) {
		props.id = camelCaseToKebab(props.name);
	}

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setIsChecked(e.target.checked);
		onChange?.(e);
	};

	return (
		<div className="checkbox-wrapper" hidden={hidden}>
			<label className="checkbox-wrapper" htmlFor={props.id}>
				<input
					type="checkbox"
					className={`form__input form__input_type_checkbox`}
					{...(isControlled ? { checked: isChecked } : { defaultChecked: isChecked })}
					required
					{...props}
					onChange={handleChange}
				/>
				<FontAwesomeIcon
					tabIndex={-1}
					icon={isChecked ? faSquareCheck : faSquare}
					height={18}
					width={16}
				/>
				{label}
			</label>
		</div>
	);
}
